<div class="h-full w-full flex flex-col overflow-y-auto overflow-x-hidden scrollbar-transparent">
    <div class="space-y-8">
        <div>
            <h2 class="text-base/7 font-semibold text-primary">Creators to Screen</h2>
            <p class="text-sm/6 text-secondary">Which creators will you be screening? Select one of the methods below...
            </p>

            <ul role="list" class="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4 px-2">
                @for (item of addCreatorOptions; track $index) {
                <li class="col-span-1 flex rounded-md border-zinc-500 cursor-pointer"
                    (click)="selectAddCreatorOption(item)">
                    <div class="flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium cursor-pointer"
                        [class]="item.class">
                        @switch (item.id) {
                        @case (1) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6">
                            <path d="M3 5h6" />
                            <path d="M3 12h13" />
                            <path d="M3 19h13" />
                            <path d="m16 8-3-3 3-3" />
                            <path d="M21 19V7a2 2 0 0 0-2-2h-6" />
                        </svg>
                        }
                        @case (2) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6">
                            <rect width="13" height="7" x="8" y="3" rx="1" />
                            <path d="m2 9 3 3-3 3" />
                            <rect width="13" height="7" x="8" y="14" rx="1" />
                        </svg>
                        }
                        @case (3) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6">
                            <path d="M12 3v12" />
                            <path d="m17 8-5-5-5 5" />
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        </svg>
                        }
                        @case (4) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6">
                            <path d="M16 5H3" />
                            <path d="M16 12H3" />
                            <path d="M11 19H3" />
                            <path d="m15 18 2 2 4-4" />
                        </svg>
                        }
                        }
                    </div>

                    <div
                        class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10 cursor-pointer">
                        <div class="flex-1 truncate px-4 py-2 text-sm">
                            <a class="font-medium text-primary hover:text-gray-200">{{ item.name
                                }}</a>
                            <p class="text-secondary truncate">{{ item.description }}</p>
                        </div>
                        <div class="shrink-0 pr-2 flex items-center justify-center text-primary">
                            @if (selectedAddCreatorOption()?.id === item.id) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <circle cx="12" cy="12" r="10" />
                                <path d="m9 12 2 2 4-4" />
                            </svg>
                            }
                        </div>
                    </div>
                </li>
                }
            </ul>
        </div>

        @switch (selectedAddCreatorOption()?.id) {
        @case (1) {
        <div class="space-y-6 border border-teal-400 bg-teal-500/10 p-4 rounded-lg sm:col-span-full">
            <div class="">
                <h2 class="text-sm font-semibold text-primary">Select Later</h2>
                <p class="text-xs text-secondary">i'll select creators later...</p>
            </div>

            <div
                class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                <h3 class="text-sm font-semibold text-primary">How do I do this?</h3>
                <ul class="mt-3 space-y-2 text-sm text-secondary">
                    <li class="flex gap-x-2">
                        <span class="mt-1 size-1.5 rounded-full bg-teal-500"></span>
                        Go to the <i>Creators</i> page and select the creators you want to screen using the "Screen"
                        button.
                    </li>
                    <li class="flex gap-x-2">
                        <span class="mt-1 size-1.5 rounded-full bg-teal-500"></span>
                        Once you've selected creators for screening, hit the button in the top right corner of the
                        screen to choose a screening brief and confirm your creator selection.
                    </li>
                </ul>
            </div>
        </div>
        }
        @case (2) {
        <div class="space-y-6 border border-red-400 bg-red-500/10 p-4 rounded-lg sm:col-span-full">
            <div class="">
                <h2 class="text-sm font-semibold text-primary">Add Manually</h2>
                <p class="text-xs text-secondary">Enter creator details one by one.</p>
            </div>

            <div
                class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 md:col-span-2">
                <div class="sm:col-span-6">
                    <label for="first-name" class="block text-sm/6 font-medium text-primary">List name</label>
                    <div class="mt-2">
                        <input [formField]="creatorListForm.listName" id="brief-title" type="text"
                            placeholder="Screening Brief title" class="input-primary text-primary" />
                        @if (creatorListForm.listName().touched() &&
                        creatorListForm.listName().invalid()) {
                        <ul class="error-list">
                            @for (error of creatorListForm.listName().errors(); track error) {
                            <li class="text-error-light flex items-start gap-1">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                                  class="shrink-0 mt-0.5" aria-hidden="true">
                                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/>
                                <path d="M12 9v4"/>
                                <path d="M12 17h.01"/>
                              </svg>
                              {{ error.message }}
                            </li>
                            }
                        </ul>
                        }
                    </div>
                </div>

                <div class="sm:col-span-6">
                    <label for="comment" class="block text-sm/6 font-medium text-primary">List description</label>
                    <div class="mt-2">
                        <textarea [formField]="creatorListForm.listDescription" id="comment" rows="2"
                            class="input-textarea text-primary"></textarea>
                    </div>
                    <p class="mt-1 text-xs leading-6 text-gray-600">Write a few sentences
                        about the list of creators.</p>
                </div>
            </div>

            <div
                class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                <div class="sm:flex sm:items-center sm:justify-between mb-4">
                    <div>
                        <h3 class="text-sm font-semibold text-primary">Creators</h3>
                        <p class="mt-1 text-xs text-secondary">Add creators to your screening list</p>
                    </div>
                    <div class="mt-4 sm:mt-0 sm:flex-none">
                        <button (click)="addCreatorRow()" type="button"
                            class="btn-shout btn-shout-xs btn-shout-primary inline-flex items-center gap-x-1.5">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-4">
                                <path d="M5 12h14" />
                                <path d="M12 5v14" />
                            </svg>
                            Add Row
                        </button>
                    </div>
                </div>
                <div class="overflow-x-auto">
                    <table class="min-w-full divide-y divide-zinc-200 dark:divide-zinc-700 rounded-lg overflow-hidden">
                        <thead class="bg-zinc-50 dark:bg-zinc-800/50 rounded-t-lg overflow-hidden">
                            <tr class="rounded-t-lg overflow-hidden">
                                <th scope="col"
                                    class="py-3 pr-3 pl-4 text-left text-xs font-semibold text-primary sm:pl-6">
                                    Creator Name</th>
                                <th scope="col" class="px-3 py-3 text-left text-xs font-semibold text-primary">
                                    Instagram Handle</th>
                                <th scope="col" class="px-3 py-3 text-left text-xs font-semibold text-primary">TikTok
                                    Handle</th>
                                <th scope="col"
                                    class="py-3 pr-4 pl-3 text-right text-xs font-semibold text-primary sm:pr-6">
                                    Actions</th>
                            </tr>
                        </thead>
                        <tbody
                            class="divide-y divide-zinc-200 dark:divide-zinc-700 bg-white dark:bg-zinc-900/50 rounded-lg overflow-hidden">
                            @for (creator of creators(); track $index) {
                            <tr [class]="$last ? 'overflow-hidden rounded-b-lg' : 'overflow-hidden'">
                                <td class="py-3 pr-3 pl-4 text-sm sm:pl-6">
                                    <input type="text" [value]="creator.creatorName"
                                        (input)="updateCreatorField($index, 'creatorName', $any($event.target).value)"
                                        placeholder="Creator name" class="input-primary text-primary w-full text-sm" />
                                </td>
                                <td class="px-3 py-3 text-sm">
                                    <input type="text" [value]="creator.instagram"
                                        (input)="updateCreatorField($index, 'instagram', $any($event.target).value)"
                                        placeholder="@handle or handle"
                                        class="input-primary text-primary w-full text-sm" />
                                </td>
                                <td class="px-3 py-3 text-sm">
                                    <input type="text" [value]="creator.tiktok"
                                        (input)="updateCreatorField($index, 'tiktok', $any($event.target).value)"
                                        placeholder="@handle or handle"
                                        class="input-primary text-primary w-full text-sm" />
                                </td>
                                <td class="py-3 pr-4 pl-3 text-right text-sm font-medium sm:pr-6">
                                    <button (click)="removeCreatorRow($index)" type="button"
                                        class="btn-fab-delete size-8 inline-flex items-center justify-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-4">
                                            <path d="M3 6h18" />
                                            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                                            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                            } @empty {
                            <tr class="rounded-b-lg">
                                <td colspan="4" class="py-8 text-center text-sm text-secondary rounded-b-lg">
                                    No creators added yet. Click "Add Row" to get started.
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
        }
        @case (3) {
        <div>
            <h2 class="text-base/7 font-semibold text-primary">Upload CSV</h2>
            <p class="text-sm/6 text-secondary">Which creators will you be screening? Select one of the methods
                below...
            </p>
        </div>

        <div
            class="space-y-6 border border-blue-400 bg-blue-500/10 p-4 rounded-lg sm:col-span-full dark:border-blue-400 dark:bg-blue-500/10">
            <div class="">
                <h2 class="text-sm font-semibold text-primary">Excel File Format</h2>
                <p class="text-xs text-secondary">Upload an Excel file (or CSV) with creator information.</p>
            </div>

            <div class="mt-8 flow-root">
                <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <div
                            class="overflow-hidden outline-1 -outline-offset-1 outline-black/5 dakr:outline-white/10 sm:rounded-lg">
                            <table
                                class="relative min-w-full divide-y divide-gray-300 dark:divide-white/15 max-w-2xl mx-auto">
                                <thead class="bg-gray-50 dark:bg-gray-800/75">
                                    <tr>
                                        <th scope="col"
                                            class="py-3 pr-3 pl-4 text-left text-xs font-semibold text-primary sm:pl-6">
                                            Creator Name</th>
                                        <th scope="col" class="px-3 py-3 text-left text-xs font-semibold text-primary">
                                            Instagram Handle</th>
                                        <th scope="col" class="px-3 py-3 text-left text-xs font-semibold text-primary">
                                            TikTok
                                            Handle</th>
                                    </tr>
                                </thead>
                                <tbody
                                    class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-800/50">
                                    <tr>
                                        <td
                                            class="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-primary sm:pl-6">
                                            Creator Name</td>
                                        <td class="px-3 py-4 text-sm whitespace-nowrap text-secondary">&#64;handle or
                                            handle
                                        </td>
                                        <td class="px-3 py-4 text-sm whitespace-nowrap text-secondary">
                                            &#64;handle or handle</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="pb-12">
            <div class="sm:col-span-full">
                <label for="comment" class="block text-sm/6 font-medium text-primary">
                    Upload Brief Document
                </label>

                <div class="mt-3 w-full overflow-hidden">
                    <atom-add-document (documentUploaded)="onDocumentUploaded($event)"></atom-add-document>
                </div>
            </div>

            <div class="w-full mt-6">
                <label for="first-name" class="block text-sm/6 font-medium text-primary">Or paste a Google Doc
                    URL</label>
                <div class="mt-2">
                    <input [formField]="creatorListForm.googleDocUrl" id="google-doc-url" type="text"
                        placeholder="https://docs.google.com/document/d/1234567890/edit"
                        class="input-primary text-primary" />
                    <p class="text-secondary text-xs mt-1">Make sure your Google Doc is publicly accessible or
                        shared with view permissions.</p>
                </div>
            </div>
        </div>




        }
        @case (4) {
        <div>
            <h2 class="text-base/7 font-semibold text-primary">Existing List</h2>
            <p class="text-sm/6 text-secondary">Which creators will you be screening? Select one of the methods
                below...
            </p>
        </div>

        <div class="flex-1 flex flex-col justify-start items-center overflow-hidden w-full">
            <div class="h-full flex-1 w-full overflow-y-auto scrollbar-transparent">
                @if (allLists() && allLists().length > 0) {
                <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    @for (list of allLists(); track list.id) {
                    <div class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10 hover:outline-2 hover:-outline-offset-2 hover:outline-primary cursor-pointer transition-all"
                        (click)="selectList(list)">
                        <div class="flex items-start gap-x-3">
                            <div
                                class="size-10 shrink-0 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5 text-gray-600 dark:text-gray-400">
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                    <circle cx="9" cy="7" r="4" />
                                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                </svg>
                            </div>
                            <div class="flex-1 min-w-0">
                                <h3 class="text-sm font-semibold text-primary truncate">{{ list.groupName }}</h3>
                                <p class="mt-1 text-xs text-secondary">
                                    {{ list.numberOfCreators || 0 }} {{ (list.numberOfCreators || 0) === 1 ? 'creator' :
                                    'creators' }}
                                </p>
                                @if (list.groupDescription) {
                                <p class="mt-1 text-xs text-secondary line-clamp-2">{{ list.groupDescription }}</p>
                                }
                                <p class="mt-2 text-xs text-secondary">
                                    {{ list.createdDate | date:'dd/MM/yyyy' }}
                                </p>
                            </div>
                            <div class="shrink-0 flex items-center">
                                @if (createScreeningService.selectedList()?.id === list.id) {
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6 text-primary">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="m9 12 2 2 4-4" />
                                </svg>
                                }
                            </div>
                        </div>
                    </div>
                    }
                </div>
                } @else {
                <div class="h-full flex items-center justify-center">
                    <div class="text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                            class="mx-auto size-12 text-gray-400">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                        <h3 class="mt-4 text-sm font-semibold text-primary">No creator lists yet</h3>
                        <p class="mt-2 text-sm text-secondary">Get started by creating your first creator list.</p>
                    </div>
                </div>
                }
            </div>
        </div>
        }
        }
    </div>
</div>